import { useMemo } from 'react';
import { useRouter } from 'next/router';
import {
  getQuizDetails,
  getOngoingSectionDetails
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';

const useOngoingSection = (sectionUID) => {
  const { query } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const ongoingSectionDetails = useSelectorWithShallowEqual(
    getOngoingSectionDetails
  );

  const hasOngoingSectional = !!ongoingSectionDetails.section;

  const currentSectionRank = useMemo(() => {
    if (!sectionUID) {
      return null;
    }

    const currentSection = quizDetails?.sections?.find(
      ({ uid }) => sectionUID === uid
    );

    return currentSection?.rank;
  }, [quizDetails?.sections, sectionUID]);

  const isLastSection = useMemo(() => {
    const currentSectionIndex = quizDetails?.sections?.findIndex(
      ({ uid }) => ongoingSectionDetails.section?.uid === uid
    );

    return currentSectionIndex === quizDetails?.sections?.length - 1;
  }, [ongoingSectionDetails, quizDetails?.sections]);

  return {
    hasOngoingSectional,
    onGoingSectionUID: hasOngoingSectional
      ? ongoingSectionDetails.section.uid
      : null,
    isLastOngoingSection: hasOngoingSectional && isLastSection,
    isCompleted:
      hasOngoingSectional &&
      currentSectionRank < ongoingSectionDetails.section.rank,
    isLocked:
      hasOngoingSectional && sectionUID !== ongoingSectionDetails.section.uid
  };
};

export default useOngoingSection;
